export default "__VITE_ASSET__22d9674e__"